import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Actions } from '../store/actions';
import { Tabs } from 'antd';
import Page from '../components/Page';
import VehicleCounts from './analytics/VehicleCounts';
import VehicleAnalytics from './analytics/VehicleAnalytics';
import UserAnalytics from './analytics/UserAnalytics';
import BlogAnalytics from './analytics/BlogAnalytics';
import VehicleUploads from './analytics/VehicleUploads';
import SignupUserAnalytics from './analytics/SignupUserAnalytics';

const Analytics = ({ activeTabKey, updateActiveTab }) => {
	const handleClick = (key) => {
		updateActiveTab(key);
	};

	return (
		<Page title="Analytics Page" className="analytics-dashboard-page">
			<Tabs onChange={handleClick} className="user-tabs" activeKey={activeTabKey} destroyInactiveTabPane={true}>
				<Tabs.TabPane tab="Vehicle Counts" key="1">
					<VehicleCounts />
				</Tabs.TabPane>
				<Tabs.TabPane tab="Vehicle Analytics" key="2">
					<VehicleAnalytics />
				</Tabs.TabPane>
				<Tabs.TabPane tab="User Analytics" key="3">
					<UserAnalytics />
				</Tabs.TabPane>
				<Tabs.TabPane tab="Blog Analytics" key="4">
					<BlogAnalytics />
				</Tabs.TabPane>
				<Tabs.TabPane tab="Vehicle Uploads" key="5">
					<VehicleUploads />
				</Tabs.TabPane>
				<Tabs.TabPane tab="User Signup Analytics" key="6">
					<SignupUserAnalytics />
				</Tabs.TabPane>
			</Tabs>
		</Page>
	);
};

const mapStateToProps = (state) => ({
	counts: state.counts,
	activeTabKey: state.activeTabKey.activeTabKey,
});

const mapDispatchToProps = (dispatch) => ({
	getCountsByPost: (value) => dispatch(Actions.getCountsByPost(value)),
	getCounts: () => dispatch(Actions.getCounts()),
	updateActiveTab: (key) => dispatch(Actions.updateActiveTab(key)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Analytics));
